const frontendShell = require('../modules/frontend-shell');

(function() {
    'use strict';

    Odigeo.Router.handlers.home = function(params) {
        var isDynpack = Odigeo.Utils.isRequestApp('dp');
        var isDeals = Odigeo.Utils.isRequestApp('deals');
        var $home = $('#home');
        var $modal = $home.find('.od-home-modal');
        var carousel;
        var bindFlexRates;
        var globalVarsGpt;
        var initializePromoBlocksTracking;
        var $newsletterHomePage = $('.newsletter_area');
        var keysForcedToBeCleared = ['UIRangeBlocked', 'page', 'returnFromUserInteraction', 'lastRouteChange',
            'residentZones', 'dontUpdatePriceBreakdownPaxPage', 'skipInsurancePage', 'summaryDataLoaded', 'offerId', 'hasFullPriceCalculate',
            'numBaggage', 'paymentMethod', 'bookedFlights', 'booking_pax_list'];
        var trackingUtils = require('../modules/utils/tracking.utils');
        var tagManagement = require('../modules/utils/tag_management.utils');
        var xsellUtils = require('../modules/utils/xsell.utils');
        var trackingIris = require('../tracking-iris');
        var CMP = require('@edreamsodigeo/frontend-cmp-client');
        _.defer(addParametersToCtLinks);
        _.defer(trackingUtils.addCrossDomainIframesTracking);
        _.defer(trackClickOnCarIframe);

        function addParametersToCtLinks() {
            xsellUtils.addParametersToElementUrl(
                document.getElementById('flights_manager_iframe_cars'),
                {currency: Odigeo.Utils.Currency.currencyCode}
            );
            xsellUtils.addParametersToElementUrl(
                document.getElementById('menu_cars'),
                {currency: Odigeo.Utils.Currency.currencyCode}
            );
            xsellUtils.addParametersToElementUrl(
                document.getElementById('flights_manager_iframe_hotels'),
                {selected_currency: Odigeo.Utils.Currency.currencyCode}
            );
        }

        function trackClickOnCarIframe() {
            const iframe = document.getElementById('flights_manager_iframe_cars');
            xsellUtils.listenClickOnIframe(iframe, () => {
                trackingUtils.trackEvent('searcher_cars', 'clicked_cars_iframe');
            });
        }

        Odigeo.Session.set('disableGrafana', false);

        trackingUtils.bindEvents($home);

        Odigeo.Router.eventController = $.extend(Odigeo.Router.eventController, Odigeo.Router.handlers.userEventController);
        Odigeo.Router.eventController = $.extend(true, Odigeo.Router.eventController, Odigeo.Router.handlers.searchFlightsEventController);
        Odigeo.Router.eventController = $.extend(true, Odigeo.Router.eventController, {
            // Global events will remain bound in any part of the application
            globalEvents: {},
            // View or local events which are triggered from this view.
            // They will be unbinded when the view changes.
            viewEvents: {
                'appCheckIn:pauseCarousel': 'onPauseCarousel',
                'appCheckIn:startCarousel': 'onStartCarousel',
            },
            // implementation of events handlers
            eventHandlers: {
                onPauseCarousel: function() {
                    if (!_.isUndefined(carousel)) {
                        carousel.trigger('pause');
                    }
                },
                onStartCarousel: function() {
                    if (!_.isUndefined(carousel)) {
                        carousel.trigger('start');
                    }
                },
            },
        });
        Odigeo.Router.eventController.execute();

        frontendShell.execute(({page}) => page.navigate('homePage'));

        $('#footer').removeClass('hidden');

        // Add tracking to internal linking component
        $(document).ready(function() {
            var internalLinkingItems = $home.find('.internal_linking_item');
            internalLinkingItems.each(function(_, item) {
                $(item).on(Odigeo.Events.click, function(evt) {
                    evt.stopPropagation();
                    var el = evt.currentTarget.nodeName === 'A' ? 'link' : 'tab';
                    var type = evt.currentTarget.dataset.itemtype;
                    trackingUtils.trackEventWithCategory(
                        Odigeo.Utils.getTrackingCategory(),
                        'footer',
                        'internal-link_click-' + el + '_' + trackingUtils.internalLinkingTypesMap[type]
                    );
                });
            });
        });

        // Add tracking to internal linking cards component
        $(document).ready(function() {
                var isWidgetLoaded = $home.find('#internal_linking_cards_widget').length > 0;
                trackingUtils.trackEventWithCategory(
                    Odigeo.Utils.getTrackingCategory(),
                    'internal-linking',
                    'internal-linking-widget-onload:' + (isWidgetLoaded ? 'Y' : 'N')
                );

                var cardsLinks = $home.find('.internal_linking_card_link');
                cardsLinks.each(function(_, link) {
                    $(link).on(Odigeo.Events.click, function(evt) {
                        evt.stopPropagation();
                        var trackingInfo = evt.currentTarget.dataset.trackinginfo;
                        trackingUtils.trackEventWithCategory(
                            Odigeo.Utils.getTrackingCategory(),
                            'internal-linking',
                            'internal-linking-click-' + trackingInfo
                        );
                    });
                });
        });

        $(document).ready(function() {
            const $headerComponent = $home.find('#header_home_component');
            const $homeTitleStatic = $home.find('#home_title_static');
            const $homeHsaSavingsExplanation = $('#home_hsa_savings_explanation_component');

            const observerCallback = function() {
                if ($headerComponent.children().length > 0) {
                    $homeTitleStatic.addClass('odf-hidden');
                    $homeHsaSavingsExplanation.addClass('odf-hidden');
                    $headerComponent.removeClass('odf-hidden');
                    observer.disconnect();
                } else {
                    $homeHsaSavingsExplanation.removeClass('odf-hidden');
                }
            };

            const observer = new MutationObserver(observerCallback);

            observer.observe($headerComponent.get(0), {
                childList: true,
                subtree: true,
            });
            observerCallback();
        });

        initializePromoBlocksTracking = function() {
            // Bind the tabs of the promoblocks
            $('.promo_tab', '#promo-blocks').off().on(Odigeo.Events.tap, function(e) {
                var $tab = $(e.currentTarget);
                var $tabs = $('.promo_tab', '#promo-blocks');
                var $tabContents = $('.promo_tab_content', '#promo-blocks');
                var tabName = $tab.data('tab');

                $tabs.removeClass('active');
                $tab.addClass('active');

                $tabContents
                    .removeClass('active')
                    .filter('[data-tab="' + tabName + '"]')
                    .addClass('active');

                // Enhance ads into this promo tab
                Odigeo.UIElements.enhanceAdvertisementGpt($tabContents.filter('[data-tab="' + tabName + '"]')
                    .find('.advertisement_gpt'), false, true, true);
                Odigeo.trigger('checkLazyImages');

                trackingUtils.trackEvent(
                    'offers_' + Odigeo.Utils.removeBlankSpaces($tab.text().replace($tab.find('.ficon').text(), '').toLowerCase()),
                    'merchandising_tab_clicks', Odigeo.History.getPageNameFromFragment());
            });

            $('#promo-blocks').off().on(Odigeo.Events.tap, '.bottom_promo_item', function(e) {
                var $el = $(e.currentTarget);
                var url = $el.data('url') || '';
                var urlTarget = '_blank' === $el.data('target') ? 'sendToPageBlank' : 'sendToPageSelf';

                if (!_.isEmpty(url)) {
                    Odigeo.trigger('analytics:tracking', {
                        type: urlTarget,
                        data: {
                            url: url,
                            goOutside: true,
                            onlyUniversal: true,
                        },
                    });
                } else {
                    trackingUtils.trackEvent({
                        'PromoBlock1': 'flights_offers',
                        'PromoBlock2': 'dynpack_offers',
                        'PromoBlock3': 'hotel_offers',
                        'PromoBlock4': 'travel_offers',
                    }[$el.closest('.promo_tab_content').data('tab')], 'select_offer_' +
                        ($el.closest('.bottom_promo_item').index() + 1), Odigeo.History.getPageNameFromFragment());
                }
            });

            trackingUtils.trackInternalCampaigns();

            $('.footer_image_link').off().on(Odigeo.Events.tap, function() {
                // Analytics: event tracking
                trackingUtils.trackEvent('footer', _.property($(this).data('type'))({
                    'apple': 'apps_open_market_apple',
                    'android': 'apps_open_market_android',
                    'tiktok': 'social_network_open_tiktok',
                    'pinterest': 'social_network_open_pinterest',
                    'instagram': 'social_network_open_instagram',
                    'blog': 'social_network_open_blog',
                    'rss': 'social_network_open_rss',
                    'facebook': 'social_network_open_facebook',
                    'youtube': 'social_network_open_youtube',
                }), Odigeo.History.getPageNameFromFragment());
            });

            $('.footer_guide').find('a[href!=""]').off().on(Odigeo.Events.tap, function() {
                // Analytics: event tracking
                trackingUtils.trackEvent('footer', 'guide_clicks', Odigeo.History.getPageNameFromFragment());
            });
        };

        bindFlexRates = function() {
            if (Odigeo.AB.isFlexibilityDisruptionEnabledDesktop) {
                var flexPageCategory = 'flights' === Odigeo.SessionScope.entryPoint ? 'hofl' : 'home';
                var evList = [
                    {
                        name: 'tap',
                        selector: '.flexibility_disruption_popup_button',
                        handler: 'onTapClosingClass',
                    },
                    {
                        name: 'tap',
                        selector: '.flex_rate_item, .flexibility_disruption_popup_button, .lightbox_close',
                        handler: 'onTrackElement',
                    },
                ];
                var flexRateTemplate = _.template($home.find('.flexibility_disruption_popup_template').html(), Odigeo.Utils.getTmplSettings());
                var $flexRateContainer = $(flexRateTemplate({
                    translations: Odigeo.UIElements.translations.flexRate,
                    flexPageCategory: flexPageCategory,
                    imgBgClass: Odigeo.AB.bestPriceGuaranteeEnabled ? 'od-best-price-bg' : 'od-flex-bg',
                }));
                var flexibleRatesLightBox = new Odigeo.UIElements.Lightbox($flexRateContainer, {
                    closeOnOuterClick: true,
                    focusClass: '',
                    evList: evList,
                });
                $home.find('.flexible_rates_button').on('click', function() {
                    flexibleRatesLightBox.toggle(true);
                    trackingUtils.trackEvent('free-cancellation_header', 'free-cancellation_more-header_pag:' + flexPageCategory);
                });
            }
        };
        // Bring the action!
        carousel = Odigeo.UIElements.enhanceCarousel($home.find('.hero_banner'));
        bindFlexRates();
        Odigeo.UIElements.enhanceCarousel($home.find('.ribbon_carousel'));

        // start quote rotation if needed
        var $homeQuotesDynamic = $('.home_dynamic_quotes_wrapper');
        if ($homeQuotesDynamic.length > 0) {
            var quotes = $homeQuotesDynamic.find('.home_dynamic_quotes li');
            var quoteIndex = 0;
            var fadeTime = 200;
            var delayTime = 1000;
            var quoteFadeIn = function() {
                quotes.eq(quoteIndex % quotes.length).fadeIn(fadeTime);
                setTimeout(quoteFadeOut, fadeTime + delayTime);
            };
            var quoteFadeOut = function() {
                quotes.eq(quoteIndex % quotes.length).fadeOut(fadeTime);
                quoteIndex++;
                setTimeout(quoteFadeIn, fadeTime);
            };
            if ($homeQuotesDynamic.data('initialized') !== true) {
                setTimeout(quoteFadeIn, fadeTime);
                $homeQuotesDynamic.data('initialized', true);
            }
        }

        // Start FlightsManager
        if (!Odigeo.Utils.isWebmasterPage()) {
            initializePromoBlocksTracking();
        }
        $home.find('.links_button').off().on(Odigeo.Events.tap, function(e) {
            $home.find('.links_group').removeClass('active');
            $home.find('.links_button').removeClass('prisma-btn-active');
            const $button = $(e.currentTarget);
            $button.parent().parent().addClass('active');
            $button.addClass('prisma-btn-active');
        });
        if (0 < $newsletterHomePage.length) {
            var newsletterSubscription = require('../modules/utils/newsletter_subscription');
            newsletterSubscription.init($newsletterHomePage, 'home');
        }
        // Remove the modal upon arrival
        $modal.removeClass('active');
        // prevent a js error when returning through back button
        if (!_.isUndefined(carousel)) {
            carousel.trigger('start');
        }

        // Session timers
        Odigeo.Utils.sessionTimer.stop();
        Odigeo.Session.clearForced(keysForcedToBeCleared);


        // Enhance ads. Only enhance ads that are shown.
        // Dont enhance ads on dynpack or hotel promo tabs until they are finally shown!
        globalVarsGpt = $home.find('.advertisement_gpt').filter(function() {
            var id = $(this).attr('id');

            return -1 === id.indexOf('adPromoBlock2') && -1 === id.indexOf('adPromoBlock3') && -1 === id.indexOf('adPromoBlock4');
        });

        if (globalVarsGpt.length) {
            Odigeo.UIElements.enhanceAdvertisementGpt(globalVarsGpt, true, true, true);
        }

        // login is not constructed because initially is hidden (funnel header is hidden), so we need to require it
        Odigeo.requireWidget('login-header', 'login');

        Odigeo.on('trackMainPageView', function() {
            // Analytics: virtual page tracking
            var trackPageViewData = {
                page: isDeals ? 'deals' : 'home',
                funnel: false,
            };
            if (CMP.isAllowed('cookies', 'iris_uid') && CMP.isAllowed('cookies', 'iris_sid')) {
                trackingIris.sendIrisTracking();
            } else {
                CMP.onChangeUserCMP((CMP) => {
                    if (CMP.isAllowed('cookies', 'iris_uid') && CMP.isAllowed('cookies', 'iris_sid')) {
                        trackingIris.sendIrisTracking();
                    }
                });
            }
            require('../redirection_by_ip');
            let dimensionValue = undefined;
            let pageCategory = undefined;
            if (!Odigeo.Utils.isWebmasterPage()) {
                _.extend(trackPageViewData, {
                    legacy: Odigeo.Utils.getFunnelTrackingLegacy(),
                    customVar: {
                        index: 35,
                        name: 'one_front_banana',
                        scope: 3,
                    },
                });
                if (!isDynpack) {
                    dimensionValue = 'no_message';
                    if (Odigeo.AB.isPriceIndex) {
                        const $priceIndexWrapper = $home.find('.price_index_wrapper');
                        dimensionValue = $priceIndexWrapper.data('trend');

                        $priceIndexWrapper.find('.price_index_button').on('click', () =>
                            trackingUtils.trackEventWithCategory(
                                Odigeo.History.getPageNameFromFragment(),
                                'banner',
                                'price-trend_click-banner_pag:home'
                            )
                        );
                    }
                }
            } else {
                pageCategory = document.querySelector('meta[name="page_category"]')
                        ?.content || 'wmp';
            }
            if (Odigeo.AB.isPricesInCalendarActive && Odigeo.AB.isInspecletActive) {
                const inspecletTracking = require('../inspeclet_tracking');
                inspecletTracking.initAndTagInspeclet(['FRO_OFIS1970'], Odigeo.SessionScope.inspecletSessionRecorderId);
            }

            Odigeo.trigger('analytics:tracking', {
                type: 'trackVirtualPage',
                data: {...trackPageViewData,
                    customDimensions: {
                        page_category: pageCategory,
                        pricing_message: dimensionValue,
                    }},
            });
            tagManagement.updateDatalayer();
        });

        // Restart ancillary step state flag
        if (!_.isNull(Odigeo.Session.get('isAncillaryStepOpenFirstTime'))) {
            Odigeo.Session.remove('isAncillaryStepOpenFirstTime');
            Odigeo.Session.remove('insuranceNagAlreadyShown');
        }

        if (0 < $('.service_bubble_animation:visible').length) {
            $('.footer_legal_dp_upsell').removeClass('hidden');
        }
    };
}());
